export const isLocalEnvironment = () =>
  ["127.0.0.1", "localhost"].includes(window.location.hostname);

export const isDevEnvironment = () =>
  isLocalEnvironment() || window.location.hostname.includes("acceptance");

export const isJestEnvironment = () => NODE_ENV === "test";
